@if (isEditingDetail()) {
  @if (selectedDetailView(); as det) {
    <div class="position-relative">
      @if (isSavingDetail() || isSavingNewDetail()) {
        <div class="position-absolute top-0 start-0 w-100 h-100 bg-white bg-opacity-75 d-flex flex-column align-items-center justify-content-center" style="z-index: 10;">
          <div class="spinner-border text-primary mb-3" role="status"></div>
          <span class="fw-semibold text-dark">Guardando daño...</span>
        </div>
      }

      <app-claim-detail-form
        [mode]="(!det.id && !det.uuid) ? formMode.CREATE : getModalFormMode(det)"
        [(detail)]="selectedDetailView"
        [partyData]="partyData()"
        [selectedVehicleType]="selectedVehicleType()"
        [deductiblePercentages]="deductiblePercentages()"
        [isTotalLoss]="isTotalLoss"
        [vehicleValue]="currentVehicleValue"
        [canEditDetails]="canEditDetails()"
        [canEditNegligence]="canEditClaimNegligence"
        [processSlug]="claimProcessSlug"
        (negligenceChange)="saveNegligenceFromReviewer($event)"
        (partsSelected)="partsSelected.emit($event)">
        @if (!det.id && !det.uuid) {
          <div claimDetailDesktopActions class="d-flex flex-wrap align-items-center gap-2 w-100">
            <button type="button" class="btn btn-outline-secondary btn-sm px-3" (click)="closeDetailEditor()" [disabled]="isSavingDetail()">Cancelar</button>
            <button type="button" class="btn btn-primary btn-sm px-3" (click)="addDetail()" [disabled]="isSavingDetail() || isSavingNewDetail()">
              <i class="fas fa-plus me-1"></i>Guardar y cargar evidencias
            </button>
          </div>
        } @else if (det.statusSlug !== 'REVIEWING' && (getModalFormMode(det) === formMode.EDIT || canEditDetails())) {
          <div claimDetailDesktopActions class="d-flex flex-wrap align-items-center gap-2 w-100">
            <button type="button" class="btn btn-primary btn-sm px-3"
              (click)="saveModalDetailChanges(selectedDetailView())"
              [disabled]="isSavingDetail()">
              <i class="fas fa-save me-1"></i>Guardar cambios
            </button>
            <span class="d-inline-flex" [attr.title]="closeDetailBlockedReason(det) || null">
              <button type="button" class="btn btn-success btn-sm px-3"
                (click)="closeDetail(det)"
                [disabled]="isSavingDetail() || !canCloseDetail(det)">
                <i class="fas fa-check-circle me-1"></i>Dejar en revisión
              </button>
            </span>
          </div>
        }
      </app-claim-detail-form>

      @if (det.id || det.uuid) {
        <app-claim-detail-document
          [detail]="det"
          [claimData]="localClaimData()"
          [mode]="mode()"
          [canEditDetails]="canEditDetails()"
          [canReplaceObserved]="canReplaceObserved()"
          [canFinalApproveDocs]="canFinalApproveDocs()"
          (documentUploaded)="documentUploaded.emit()">
        </app-claim-detail-document>
      }

      @if (!appSettings.isMobile() && (det.id || det.uuid) && canEditDetails()) {
        <div class="d-flex flex-wrap align-items-center gap-2 mt-3 pt-3">
          @if (det.statusSlug !== 'APPROVED') {
            @if (approveDetailBlockedReason(det); as blockedApprove) {
              <div class="alert alert-warning py-2 px-3 small mb-0 d-inline-flex align-items-center">
                <i class="fas fa-exclamation-triangle me-2"></i>{{ blockedApprove }}
              </div>
            } @else {
              <button type="button" class="btn btn-success btn-sm px-3" (click)="approveDetail(det)">
                <i class="fas fa-check me-1"></i>Aprobar Daño
              </button>
            }
          }
          @if (det.statusSlug !== 'REJECTED') {
            <button type="button" class="btn btn-danger btn-sm px-3" (click)="rejectDetail(det)">
              <i class="fas fa-times me-1"></i>Rechazar Daño
            </button>
          }
        </div>
      } @else if (appSettings.isMobile() && canEditDetails()) {
        <div class="d-flex justify-content-between align-items-center mt-4 pt-3 border-top">
          @if (det.statusSlug !== 'APPROVED') {
            @if (approveDetailBlockedReason(det); as blockedApprove) {
              <div class="alert alert-warning py-2 px-3 small mb-0 me-2 d-inline-flex align-items-center">
                <i class="fas fa-exclamation-triangle me-2"></i>{{ blockedApprove }}
              </div>
            } @else {
              <button type="button" class="btn btn-success btn-sm px-3 me-2" (click)="approveDetail(det)">
                <i class="fas fa-check me-1"></i>Aprobar
              </button>
            }
          }
          @if (det.statusSlug !== 'REJECTED') {
            <button type="button" class="btn btn-danger btn-sm px-3" (click)="rejectDetail(det)">
              <i class="fas fa-times me-1"></i>Rechazar
            </button>
          }
        </div>
      }
    </div>
  }
} @else {
  <div class="row g-4 mb-4">
    <div class="col-lg-8 col-md-7 order-2 order-md-1" [class.col-12]="appSettings.isMobile()">
      <app-claim-detail-list
        [details]="claimDetails()"
        [mode]="mode()"
        [partyData]="partyData()"
        [isTotalLoss]="isTotalLoss"
        [vehicleValue]="currentVehicleValue"
        [selectedVehicleType]="selectedVehicleType()"
        [claimDocuments]="localClaimData()?.documents || []"
        [canCreate]="mode() !== formMode.VIEW && canRegisterAnotherDetail().ok"
        (open)="openDetailView($event)"
        (create)="openCreateDetail()"
        (remove)="removeDetail($event)">
      </app-claim-detail-list>
    </div>

    <div class="col-lg-4 col-md-5 order-1 order-md-2" [class.col-12]="appSettings.isMobile()">
      <app-claim-summary
        [laborCost]="laborCost"
        [partsCost]="partsCost"
        [totalCost]="totalCost"
        [totalDeductible]="totalDeductible"
        [netReimbursement]="netReimbursement"
        [isTotalLoss]="isTotalLoss"
        [vehicleValue]="currentVehicleValue"
        [retentionPct]="totalLossRetentionPct"
        [isNegligence]="claimIsNegligence"
        [canEditNegligence]="false">
      </app-claim-summary>
    </div>
  </div>
}

@if (isViewerOpen) {
  <app-viewer
    title="Evidencia de Daño"
    [items]="viewerItems"
    [activeId]="activeViewerId"
    (onSelect)="activeViewerId = $event"
    (close)="isViewerOpen = false"
    [allowDelete]="false">
    @if (canEditDetails() && isStatusEditable && getActiveViewerDoc()?.statusSlug !== 'APPROVED') {
      <div viewer-actions class="d-flex gap-2">
        <button type="button" class="btn btn-success btn-xs px-3" (click)="approveViewerDoc()">
          <i class="fas fa-check me-1"></i> Aprobar Documento
        </button>
        <button type="button" class="btn btn-danger btn-xs px-3" (click)="rejectViewerDoc()">
          <i class="fas fa-times me-1"></i> Rechazar Documento
        </button>
      </div>
    }
  </app-viewer>
}
